import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { formatDateDDMMYYYY, formatTimeWAT } from "@/lib/format";
import { toast } from "sonner";

export const GuardShifts = () => {
  const [shifts, setShifts] = useState([]);
  const [sites, setSites] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/shifts");
    setShifts(r.data);
  }, []);

  useEffect(() => {
    load();
    api.get("/sites").then(r => setSites(r.data));
  }, [load]);

  const siteName = (id) => sites.find(s => s.id === id)?.name || "—";

  const confirm = async (id) => {
    await api.put(`/shifts/${id}/confirm`);
    toast.success("Shift confirmed");
    load();
  };

  const upcoming = shifts.filter(s => new Date(s.end_at) > new Date()).slice(0, 20);

  return (
    <div className="space-y-3">
      <div className="text-muted" style={{ fontSize: 13 }}>{upcoming.length} upcoming</div>
      {upcoming.map(s => (
        <div key={s.id} className="s-card" data-testid={`gshift-${s.id}`}>
          <div className="flex justify-between items-start mb-2">
            <div>
              <div style={{ fontSize: 15, color: "#fff" }}>{siteName(s.site_id)}</div>
              <div className="text-muted mono" style={{ fontSize: 12, marginTop: 4 }}>
                {formatDateDDMMYYYY(s.start_at)} · {formatTimeWAT(s.start_at)} → {formatTimeWAT(s.end_at)}
              </div>
            </div>
            <StatusBadge status={s.status} />
          </div>
          {!s.confirmed && s.status === "SCHEDULED" && (
            <button onClick={() => confirm(s.id)} className="btn-primary w-full tap-target" data-testid={`confirm-${s.id}`}>
              Confirm shift
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
